import { useLocation } from 'react-router-dom';
import AppHeader from './AppHeader';
import AppMiniHeader from './AppMiniHeader';
import BottomNavigation from './BottomNavigation';

function AppLayout({ children }) {
  const { pathname } = useLocation();
  const Header = pathname === '/' ? AppHeader : AppMiniHeader;

  return (
    <div className="min-h-dvh bg-slate-100">
      <div className="mx-auto flex min-h-dvh w-full max-w-app flex-col bg-white shadow-2xl shadow-slate-200/70">
        <Header />

        <main className="flex-1 px-5 pt-3 pb-6">{children}</main>

        <BottomNavigation />
      </div>
    </div>
  );
}

export default AppLayout;
